import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  TabStopType,
  TabStopPosition,
  BorderStyle,
} from "docx";

interface RESPAWordData {
  currentYear: number;
}

export async function generateRESPAWord(data: RESPAWordData): Promise<void> {
  const previousYear = data.currentYear - 1;

  const underlineBorder = {
    bottom: { style: BorderStyle.SINGLE, size: 6, color: "000000", space: 1 },
  };

  const doc = new Document({
    styles: {
      default: {
        document: {
          run: { font: "Arial", size: 24 }, // 12pt
        },
      },
    },
    sections: [
      {
        properties: {
          page: {
            size: { width: 12240, height: 15840 },
            margin: { top: 1440, right: 1440, bottom: 1440, left: 1440 },
          },
        },
        children: [
          // Title
          new Paragraph({
            alignment: AlignmentType.CENTER,
            spacing: { after: 600 },
            children: [
              new TextRun({ text: "RESPA Compliance Form", bold: true, size: 36 }),
            ],
          }),

          // Question 1
          new Paragraph({
            spacing: { after: 120 },
            children: [
              new TextRun({
                text: `How many Notes/Contracts did you originate in ${previousYear}?`,
                bold: true,
                size: 24,
              }),
            ],
          }),
          // Answer line
          new Paragraph({
            spacing: { after: 400 },
            border: underlineBorder,
            indent: { left: 360 },
            children: [
              new TextRun({ text: " ", size: 24 }),
            ],
          }),

          // Question 2
          new Paragraph({
            spacing: { after: 120 },
            children: [
              new TextRun({
                text: "How many had an interest rate of 9% or more?",
                bold: true,
                size: 24,
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 400 },
            border: underlineBorder,
            indent: { left: 360 },
            children: [
              new TextRun({ text: " ", size: 24 }),
            ],
          }),

          // Question 3
          new Paragraph({
            spacing: { after: 120 },
            children: [
              new TextRun({
                text: `How many Notes/Contracts did you originate in ${data.currentYear}, including the Note you are looking to sell?`,
                bold: true,
                size: 24,
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 400 },
            border: underlineBorder,
            indent: { left: 360 },
            children: [
              new TextRun({ text: " ", size: 24 }),
            ],
          }),

          // Question 4
          new Paragraph({
            spacing: { after: 120 },
            children: [
              new TextRun({
                text: "How many had an interest rate of 9% or more?",
                bold: true,
                size: 24,
              }),
            ],
          }),
          new Paragraph({
            spacing: { after: 600 },
            border: underlineBorder,
            indent: { left: 360 },
            children: [
              new TextRun({ text: " ", size: 24 }),
            ],
          }),

          // Spacer
          new Paragraph({ spacing: { after: 600 }, children: [] }),

          // Signature line
          new Paragraph({
            tabStops: [
              { type: TabStopType.LEFT, position: 5400 },
            ],
            children: [
              new TextRun({ text: "Signed", bold: true, size: 24 }),
              new TextRun({ text: "\t", size: 24 }),
              new TextRun({ text: "Date", bold: true, size: 24 }),
            ],
          }),
          new Paragraph({
            tabStops: [
              { type: TabStopType.LEFT, position: 5400 },
            ],
            spacing: { before: 600 },
            children: [
              new TextRun({ text: "________________________________", size: 24 }),
              new TextRun({ text: "\t", size: 24 }),
              new TextRun({ text: "________________________________", size: 24 }),
            ],
          }),
        ],
      },
    ],
  });

  const buffer = await Packer.toBlob(doc);
  const url = URL.createObjectURL(buffer);
  const link = document.createElement("a");
  link.href = url;
  link.download = `RESPA_Compliance_Form_${data.currentYear}.docx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
